export const onAdvancedSearchViewed: (
	searchSessionId: string,
	referrer?: string,
) => {
	name: string;
	attributes: {
		additionalAttributes: {
			searchSessionId: string;
			referrer: string | undefined;
		};
	};
} = (searchSessionId: string, referrer?: string) => ({
	name: 'advancedSearchScreen',
	attributes: {
		additionalAttributes: {
			// we're not passing the application mode since this event is triggered before the application mode is set
			searchSessionId,
			referrer,
		},
	},
});
